export default __webpack_public_path__ + "static/media/about-section.589429a8.jpg";